import styled from "@emotion/styled";

import { StyledIconHeadphoneSvg } from "scmp-app/components/article/article-speech/article-speech-inline-widget/variants/generic/button/headphone-icon/styles";
import { MinifyContainer } from "scmp-app/components/article/article-speech/article-speech-inline-widget/variants/generic/button/styles";
import { Wrapper } from "scmp-app/components/article/article-speech/article-speech-inline-widget/variants/generic/styles";
import { ResponsiveContainer } from "scmp-app/components/header/features/styles";

export const Container = styled(ResponsiveContainer)`
  &:empty {
    display: none;
  }

  ${Wrapper} {
    display: flex;
  }

  ${MinifyContainer} {
    display: flex;

    block-size: auto;
  }

  ${StyledIconHeadphoneSvg} {
    inline-size: 27px;
    block-size: 24px;
  }
`;
